import React, { useContext, useEffect, useRef, useState } from "react";
import { Stage, Layer, Image as KImage, Line, Group, Rect } from "react-konva";
import useImage from "use-image";
import { toast } from "react-toastify";
import trans, { isRTL } from "../../../../utils";
import { useSelector } from "react-redux";
import { popupcontext } from "../../../../context/Popupscontext";

const MAX_SCALE = 5;

export default function SetupKonva({
	floorplan,
	rooms,
	setUniqueId,
	col,
	roomId,
}) {
	const containerRef = useRef(null);
	const fitScaleRef = useRef(1);
	const minScaleRef = useRef(1);
	const [scale, setScale] = useState(1);
	const [position, setPosition] = useState({ x: 0, y: 0 });
	const [stageSize, setStageSize] = useState({ width: 0, height: 0 });
	const [polygons, setPolygons] = useState([]);
	const [points, setPoints] = useState([]);
	const [pointImg] = useImage(
		"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIGZpbGw9IiMyRTkyNDUiLz4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIHN0cm9rZT0iI0JFRERDNSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yNyAxNEgyMUMxNy42OTA3IDE0IDE3IDE0LjY5MDcgMTcgMThWMzRIMzFWMThDMzEgMTQuNjkwNyAzMC4zMDkzIDE0IDI3IDE0WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1IDM0SDMzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNyAzNFYzMUMyNyAyOS4zNDUzIDI2LjY1NDcgMjkgMjUgMjlIMjNDMjEuMzQ1MyAyOSAyMSAyOS4zNDUzIDIxIDMxVjM0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjUuNSAxOEgyMi41TTI1LjUgMjEuNUgyMi41TTI1LjUgMjVIMjIuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K",
	);
	const [selectedPointImg] = useImage(
		"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIGZpbGw9IiMxODkwRkYiLz4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIHN0cm9rZT0iI0U2RjdGRiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yNyAxNEgyMUMxNy42OTA3IDE0IDE3IDE0LjY5MDcgMTcgMThWMzRIMzFWMThDMzEgMTQuNjkwNyAzMC4zMDkzIDE0IDI3IDE0WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1IDM0SDMzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNyAzNFYzMUMyNyAyOS4zNDUzIDI2LjY1NDcgMjkgMjUgMjlIMjNDMjEuMzQ1MyAyOSAyMSAyOS4zNDUzIDIxIDMxVjM0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjUuNSAxOEgyMi41TTI1LjUgMjEuNUgyMi41TTI1LjUgMjVIMjIuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K",
	);
	const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

	const markerScreenSize = clamp(32 * Math.sqrt(scale), 18, 48);
	const markerInternal = markerScreenSize / scale;
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const { setConfigurationId } = useContext(popupcontext);
	useEffect(() => {
		// if (offlineMode) return () => dispatch(setConfigId(null));
		if (!offlineMode) return () => setConfigurationId(null);
	}, [offlineMode, setConfigurationId]);
	// useEffect(() => {
	// 	if (!isError || !error) return;

	// 	// RTK Query error shape
	// 	const status = error?.status;

	// 	if (status === 502) {
	// 		toast.error(trans("Failed to generate layout. Please reload the page."), {
	// 			autoClose: 2000,
	// 			rtl: localStorage.getItem("lang") === "ar",
	// 		});
	// 	}
	// }, [isError, error]);

	const [img] = useImage(floorplan);

	useEffect(() => {
		if (!Array.isArray(rooms)) return;

		const points = rooms.filter((r) => r?.drawingType === "point");

		const polygons = rooms.filter(
			(r) =>
				r?.drawingType === "polygon" &&
				Array.isArray(r?.drawingCoordinates) &&
				r.drawingCoordinates.length > 0,
		);

		setPoints(points);
		setPolygons(polygons);
	}, [rooms]);

	const flatPoints = (poly) => poly.flatMap((p) => [p.x, p.y]);

	// 🔒 Clamp pan so image never hides
	const clampPosition = (pos, scaleValue = scale) => {
		if (!img) return pos;

		const imgW = img.width * scaleValue;
		const imgH = img.height * scaleValue;

		const minX = Math.min(0, stageSize.width - imgW);
		const minY = Math.min(0, stageSize.height - imgH);

		return {
			x: Math.max(minX, Math.min(0, pos.x)),
			y: Math.max(minY, Math.min(0, pos.y)),
		};
	};

	// ✅ Fit image
	useEffect(() => {
		if (!floorplan || !containerRef.current) return;
		const toastId = toast(trans("Layout is loading..."), {
			type: "info",
			isLoading: true,
			autoClose: false,
			closeOnClick: false,
			rtl: isRTL,
		});

		const image = new window.Image();
		image.src = floorplan;

		image.onload = () => {
			if (!containerRef.current) return;
			const cw = containerRef.current.offsetWidth;
			const ch = containerRef.current.offsetHeight;

			const fitScale = Math.min(
				cw / image.naturalWidth,
				ch / image.naturalHeight,
			);

			const pos = {
				x: (cw - image.naturalWidth * fitScale) / 2,
				y: (ch - image.naturalHeight * fitScale) / 2,
			};

			fitScaleRef.current = fitScale;
			minScaleRef.current = fitScale;

			setScale(fitScale);
			setPosition(pos);
			setStageSize({ width: cw, height: ch });
			// ✅ update toast to success
			toast.update(toastId, {
				render: trans("Layout ready"),
				type: "success",
				isLoading: false,
				autoClose: 1000,
				rtl: isRTL,
			});
		};

		image.onerror = () => {
			toast.update(toastId, {
				render: trans("Failed to load layout"),
				type: "error",
				isLoading: false,
				autoClose: 2000,
				rtl: isRTL,
			});
		};

		// cleanup in case component unmounts
		return () => {
			toast.dismiss(toastId);
		};
	}, [floorplan]);

	// ✅ Zoom logic (shared)
	const applyZoom = (newScale, center) => {
		const mousePointTo = {
			x: (center.x - position.x) / scale,
			y: (center.y - position.y) / scale,
		};

		const pos = {
			x: center.x - mousePointTo.x * newScale,
			y: center.y - mousePointTo.y * newScale,
		};

		setScale(newScale);
		setPosition(clampPosition(pos, newScale));
	};

	// ➕➖ Zoom buttons
	const zoomIn = () =>
		applyZoom(Math.min(scale * 1.2, MAX_SCALE), {
			x: stageSize.width / 2,
			y: stageSize.height / 2,
		});

	const zoomOut = () =>
		applyZoom(Math.max(scale / 1.2, minScaleRef.current), {
			x: stageSize.width / 2,
			y: stageSize.height / 2,
		});
	// 🗑 Delete

	return (
		<div className={`${!col ? "col-lg-8" : col}`}>
			<div
				style={{
					backgroundColor: "white",
					borderRadius: "16px",
					height: "calc(100vh - 78px)",
					marginBlock: "8px",
					position: "relative",
				}}
			>
				{" "}
				<div
					style={{
						position: "absolute",
						zIndex: "1",
						left: "95%",
						top: "10%",
						display: "flex",
						flexDirection: "column",
					}}
				></div>
				{/* ➕➖ ZOOM UI */}
				<div className="konva-zoom ">
					<div
						disabled={scale >= MAX_SCALE}
						onClick={zoomIn}
						className="konva-tool-zoom mb-2"
					>
						+
					</div>
					<div
						disabled={scale <= minScaleRef.current}
						onClick={zoomOut}
						className="konva-tool-zoom"
					>
						−
					</div>
				</div>
				<div
					ref={containerRef}
					style={{
						width: "100%",
						height: "100%",
						overflow: "auto",
						borderRadius: "16px",
						border: "1px solid #c4c6c9ff",
						backgroundColor: "#0000001c",
					}}
				>
					<Stage width={stageSize.width} height={stageSize.height}>
						<Layer>
							<Group
								x={position.x}
								y={position.y}
								scaleX={scale}
								scaleY={scale}
								draggable={scale > minScaleRef.current} // ✅ only draggable when zoomed
								onDragMove={(e) => {
									const newPos = {
										x: e.target.x(),
										y: e.target.y(),
									};
									setPosition(clampPosition(newPos));
								}}
								onDragStart={(e) => {
									// ❌ block drag when not zoomed
									if (scale <= minScaleRef.current) {
										e.target.stopDrag();
									}
								}}
							>
								{img && <KImage image={img} />}
								<Rect
									x={0}
									y={0}
									width={img?.width}
									height={img?.height}
									fill="#f1f2f5ff"
									opacity={0.4}
								/>
								{polygons.map((poly, idx) => {
									const isSelected = roomId === (poly?.id || poly?.poiId);

									return (
										<Line
											key={poly.id ?? idx}
											points={flatPoints(poly.drawingCoordinates)}
											closed
											stroke={isSelected ? "#1890ff" : "#22c55e"}
											strokeWidth={isSelected ? 4 : 2}
											fill={
												isSelected ? "rgb(24, 143, 255)" : "rgba(34,197,94,0.2)"
											}
											زرق
											onClick={() => {
												console.log("Selected Polygon", poly);
												setUniqueId(poly?.id || poly?.poiId);
											}}
										/>
									);
								})}
								{points.map((p, i) => {
									const isSelected = roomId === (p?.id || p?.poiId);

									return (
										<>
											<KImage
												key={i}
												image={!isSelected ? pointImg : selectedPointImg}
												x={p?.drawingCoordinates[0]?.x}
												y={p?.drawingCoordinates[0]?.y}
												width={markerInternal}
												height={markerInternal}
												offsetX={markerInternal / 2}
												offsetY={markerInternal / 2}
												onClick={() => {
													console.log("Selected Point", p);
													setUniqueId(p?.id || p?.poiId);
												}}
												shadowColor={isSelected ? "#0084ff" : "#030302ff"} // ظل أزرق
												shadowBlur={isSelected ? 15 : 0} // ظل أكبر لو selected
											/>
										</>
									);
								})}
							</Group>
						</Layer>
					</Stage>
				</div>
			</div>
		</div>
	);
}
